import { CheckTaxRates } from './checkTaxRates';
import { formatDateOnRead } from '../../time/formatTimezoneOffset';
import { DocumentData, DocumentSnapshot, QueryDocumentSnapshot } from '@firebase/firestore-types';
import { OrganizationData } from '../../../interfaces/organizationData';

const UNDEFINED = 'undefined';

export default function checkOrg(orgSnap: QueryDocumentSnapshot<DocumentData> | DocumentSnapshot<DocumentData>) {
  const org = orgSnap.data();
  if (!org) return;

  const orgId = () => {
    if (typeof orgSnap.id !== UNDEFINED) {
      return orgSnap.id;
    }
    return '';
  };
  const companyName = () => {
    if (typeof org.companyName !== UNDEFINED) {
      return org.companyName;
    }
    return '';
  };
  const companyAddress = () => {
    if (typeof org.companyAddress !== UNDEFINED) {
      return org.companyAddress;
    }
    return '';
  };
  const showCompanyAddress = () => {
    if (typeof org.showCompanyAddress !== UNDEFINED) {
      return org.showCompanyAddress;
    }
    return true;
  };
  const allowInventoryMaintenance = () => {
    if (typeof org.allowInventoryMaintenance !== UNDEFINED) {
      return org.allowInventoryMaintenance;
    }
    return false;
  };
  const companyPhone = () => {
    if (typeof org.companyPhone !== UNDEFINED) {
      return org.companyPhone;
    }
    return '';
  };
  const companyWebsite = () => {
    if (typeof org.companyWebsite !== UNDEFINED) {
      return org.companyWebsite;
    }
    return '';
  };
  const webTaxName = () => {
    if (typeof org.webTaxName !== UNDEFINED) {
      return org.webTaxName;
    }
    return '';
  };
  const adminEmail = () => {
    if (typeof org.adminEmail !== UNDEFINED) {
      return org.adminEmail;
    }
    return '';
  };
  const setUseAdminEmailReply = () => {
    if (typeof org.useAdminEmailReply !== UNDEFINED) {
      return org.useAdminEmailReply;
    }
    return false;
  };
  const webTransactionType = () => {
    if (typeof org.webTransactionType !== UNDEFINED) {
      return org.webTransactionType;
    }
    return '';
  };
  const qbInvoiceDate = () => {
    if (typeof org.qbInvoiceDate !== UNDEFINED) {
      return org.qbInvoiceDate;
    }
    return '';
  };
  const companyOpenTime = () => {
    if (typeof org.companyOpenTime !== UNDEFINED) {
      return org.companyOpenTime;
    }
    return null;
  };
  const companyCloseTime = () => {
    if (typeof org.companyCloseTime !== UNDEFINED) {
      return org.companyCloseTime;
    }
    return null;
  };
  const countryCode = () => {
    if (typeof org.countryCode !== UNDEFINED) {
      return org.countryCode;
    }
    return 'US';
  };
  const currencyCode = () => {
    if (typeof org.currencyCode !== UNDEFINED) {
      return org.currencyCode;
    }
    return 'USD';
  };
  const languageCode = () => {
    if (typeof org.languageCode !== UNDEFINED) {
      return org.languageCode;
    }
    return 'en';
  };
  const updatedBy = () => {
    if (typeof org.updatedBy !== UNDEFINED) {
      return org.updatedBy;
    }
    return '';
  };
  const currentInvoiceCount = () => {
    if (typeof org.currentInvoiceCount !== UNDEFINED) {
      return org.currentInvoiceCount;
    }
    return null;
  };
  const taxRate = () => {
    if (typeof org.taxRate !== UNDEFINED) {
      return CheckTaxRates(org.taxRate, true);
    }
    return null;
  };
  const qboRealmId = () => {
    if (typeof org.qboRealmId !== UNDEFINED) {
      return org.qboRealmId;
    }
    return null;
  };
  const integrations = () => {
    if (typeof org.integrations !== UNDEFINED) {
      return org.integrations;
    } else {
      return {
        qbOnline: false,
        qbDesktop: false,
        stripe: false,
      };
    }
  };

  const bundleManagedBy = () => {
    if (typeof org.bundleManagedBy !== UNDEFINED) {
      return org.bundleManagedBy;
    }
    return null;
  };

  const stripeEnabled = () => {
    if (typeof org.stripeEnabled !== UNDEFINED) {
      return org.stripeEnabled;
    }
    return false;
  };

  const automaticallyConvertEstimate = () => {
    if (typeof org.automaticallyConvertEstimate !== UNDEFINED) {
      return org.automaticallyConvertEstimate;
    }
    return true;
  };

  const showInvoiceItemImg = () => {
    if (typeof org.showInvoiceItemImg !== UNDEFINED) {
      return org.showInvoiceItemImg;
    }
    return true;
  };

  const showItemName = () => {
    if (typeof org.showItemName !== UNDEFINED) {
      return org.showItemName;
    }
    return true;
  };

  const showDuration = () => {
    if (typeof org.showDuration !== UNDEFINED) {
      return org.showDuration;
    }
    return true;
  };

  const showRate = () => {
    if (typeof org.showRate !== UNDEFINED) {
      return org.showRate;
    }
    return true;
  };

  const showDescription = () => {
    if (typeof org.showDescription !== UNDEFINED) {
      return org.showDescription;
    }
    return true;
  };

  const showTotal = () => {
    if (typeof org.showTotal !== UNDEFINED) {
      return org.showTotal;
    }
    return true;
  };

  const defaultDepositPercent = () => {
    if (typeof org.defaultDepositPercent !== UNDEFINED) {
      return org.defaultDepositPercent;
    }
    return 100;
  };
  const deliveryFeeTaxable = () => {
    if (typeof org.deliveryFeeTaxable !== UNDEFINED) {
      return org.deliveryFeeTaxable;
    }
    return true;
  };

  const qbBidirectionalSync = () => {
    if (typeof org.qbBidirectionalSync !== UNDEFINED) {
      return org.qbBidirectionalSync;
    }
    return false;
  };
  const stripeAccount = () => {
    if (typeof org.stripeAccount !== UNDEFINED) {
      return org.stripeAccount;
    }
    return null;
  };
  const stripeDetailsSubmitted = () => {
    if (typeof org.stripeDetailsSubmitted !== UNDEFINED) {
      return org.stripeDetailsSubmitted;
    }
    return false;
  };
  const orgTimezone = () => {
    if (typeof org.orgTimezone !== UNDEFINED) {
      return org.orgTimezone;
    }
    return 'America/Phoenix';
  };
  const timezoneOffsets = () => {
    const tz = orgTimezone();
    const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  };

  const logoUrl = () => {
    if (typeof org.logoUrl !== UNDEFINED) {
      return org.logoUrl;
    }
    return '';
  };
  const eventDateEnabled = () => {
    if (typeof org.eventDateEnabled !== UNDEFINED) {
      return org.eventDateEnabled;
    }
    return false;
  };
  const salesInvoiceEnabled = () => {
    if (typeof org.salesInvoiceEnabled !== UNDEFINED) {
      return org.salesInvoiceEnabled;
    }
    return false;
  };
  const embeddedCheckoutEnabled = () => {
    if (typeof org.embeddedCheckoutEnabled !== UNDEFINED) {
      return org.embeddedCheckoutEnabled;
    }
    return false;
  };

  const orgData: OrganizationData = {
    id: orgId(),
    allowInventoryMaintenance: allowInventoryMaintenance(),
    companyName: companyName(),
    companyAddress: companyAddress(),
    showCompanyAddress: showCompanyAddress(),
    companyPhone: companyPhone(),
    companyWebsite: companyWebsite(),
    countryCode: countryCode(),
    languageCode: languageCode(),
    currencyCode: currencyCode(),
    embeddedCheckoutEnabled: embeddedCheckoutEnabled(),
    webTaxName: webTaxName(),
    adminEmail: adminEmail(),
    useAdminEmailReply: setUseAdminEmailReply(),
    webTransactionType: webTransactionType(),
    qbInvoiceDate: qbInvoiceDate(),
    companyOpenTime: companyOpenTime(),
    companyCloseTime: companyCloseTime(),
    updatedBy: updatedBy(),
    currentInvoiceCount: currentInvoiceCount(),
    bundleManagedBy: bundleManagedBy(),
    taxRate: taxRate(),
    qboRealmId: qboRealmId(),
    stripeEnabled: stripeEnabled(),
    automaticallyConvertEstimate: automaticallyConvertEstimate(),
    showInvoiceItemImg: showInvoiceItemImg(),
    showItemName: showItemName(),
    showDuration: showDuration(),
    showRate: showRate(),
    showDescription: showDescription(),
    showTotal: showTotal(),
    deliveryFeeTaxable: deliveryFeeTaxable(),
    defaultDepositPercent: defaultDepositPercent(),
    qbBidirectionalSync: qbBidirectionalSync(),
    integrations: integrations(),
    stripeAccount: stripeAccount(),
    stripeDetailsSubmitted: stripeDetailsSubmitted(),
    orgTimezone: orgTimezone(),
    logoUrl: logoUrl(),
    eventDateEnabled: eventDateEnabled(),
    salesInvoiceEnabled: salesInvoiceEnabled(),
  };
  return convertOpenCloseTimes(orgData);
}

const convertOpenCloseTimes = (orgData: OrganizationData) => {
  const tz = orgData?.orgTimezone;
  const companyOpenTime = orgData?.companyOpenTime
    ? formatDateOnRead({
        date: orgData?.companyOpenTime,
        orgTimezone: tz,
      })
    : null;
  const companyCloseTime = orgData?.companyCloseTime
    ? formatDateOnRead({
        date: orgData?.companyCloseTime,
        orgTimezone: tz,
      })
    : null;

  return {
    ...orgData,
    companyOpenTime,
    companyCloseTime,
  };
};
